import { Alert, Modal, Select } from "antd";
import { useEffect, useMemo, useState } from "react";
import { useMoveExpenseToTrip } from "../../api/api";
import { useGetAllTrips } from "../../api/api.get";
import { useGroupContext } from "../../providers/groups.provider";
import { IExpense2 } from "../../types/types";

export default function SaveAsTripExpenseDialog({
  open,
  onCancel,
  onOk,
  expense,
}: {
  expense?: IExpense2;
  open: boolean;
  onCancel: () => void;
  onOk: () => void;
}) {
  const { defaultGroupId } = useGroupContext();
  const { data: tripsData } = useGetAllTrips(defaultGroupId || "");

  const { mutateAsync, error } = useMoveExpenseToTrip(
    defaultGroupId,
    expense?.id,
  );

  const optionsData = useMemo(() => {
    if (tripsData) {
      return tripsData.map((t) => {
        return { label: t.name, value: t.id };
      });
    }
  }, [tripsData]);

  const [selectedTrip, setSelectedTrip] = useState<string | undefined>();

  useEffect(() => {
    if (tripsData) {
      setSelectedTrip(tripsData[0]?.id);
    }
  }, [tripsData]);

  const handleSubmit = () => {
    mutateAsync({ tripId: selectedTrip! }).then(onOk);
  };

  return (
    <Modal
      title="Change To Trip Expense?"
      closable={{ "aria-label": "Custom Close Button" }}
      open={open}
      onOk={handleSubmit}
      onCancel={onCancel}
    >
      <div className="flex flex-col justify-center items-center mb-10">
        {error && (
          <Alert type="error" title={"Unable to process. Please try again"} />
        )}
        <div className="flex mt-4 gap-5">
          <Select
            style={{ width: 300 }}
            placeholder="Select a trip"
            onChange={(value) => setSelectedTrip(value)}
            options={optionsData}
            value={selectedTrip}
          />
        </div>
      </div>
    </Modal>
  );
}
